<template>
    <div class="row">
        <div class="col-lg-12">
            <h1 class="page-header">Responsáveis pelos Compromissos</h1>

            <!-- Filtro por unidade -->
            <div class="form-group col-sm-4">
                <div class="inputgroupcontainer">
                    <div class="input-group">
                        <span class="input-group-addon">
                            <font-awesome-icon :icon="'sitemap'"></font-awesome-icon>
                        </span>
                        <select class="form-control select-selected" v-model="filtro.unidade_executora">
                            <option value="*">Todas</option>
                            <option v-for="unidade in unidadesDisponiveis" :key="unidade" :value="unidade">
                                {{ unidade }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>

            <!-- Lista de compromissos -->
            <div class="col-xs-12">
                <table class="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th>Unidade</th>
                            <th>Compromisso</th>
                            <th class="text-center">Responsável</th>
                            <th class="text-center">Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="compromissosFiltrados.length === 0">
                            <td class="text-center" colspan="4">Nenhum compromisso encontrado!</td>
                        </tr>
                        <tr v-else v-for="comp in compromissosFiltrados" :key="comp.id">
                            <td>{{ comp.unidade_executora }}</td>
                            <td>{{ comp.descritivo }}</td>
                            <td class="text-center">{{ comp.responsavel_sshd }}</td>
                            <td class="text-center">
                                <button title="Trocar Responsável" class="btn btn-primary" @click="editar(comp)">
                                    <font-awesome-icon icon="user-edit" />
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Modal para troca de responsável -->
            <div v-if="modal.visivel" class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">

                        <h4 class="modal-title">
                            <font-awesome-icon icon="user-edit" />
                            Alterar Responsável
                        </h4>

                        <p><strong>Compromisso:</strong> {{ modal.compromisso.descritivo }}</p>

                        <SelectFuncionario ref="selectFuncionario" v-model="modal.novoResponsavel" :label="''" :name="'novoResponsavel'"
                            :placeholder="'Pesquise pelo nome ou SSHD'" />

                        <div class="modal-footer">
                            <button class="btn btn-success" @click="salvarResponsavel">Salvar</button>
                            <button class="btn btn-default" @click="fecharModal">Cancelar</button>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import SelectFuncionario from '@/components/SelectFuncionario'
import { request } from '@/request'

export default {
    components: { SelectFuncionario },
    data() {
        return {
            filtro: {
                unidade_executora: '*'
            },
            todosOsCompromissos: [], 
            funcionarios: [],
            modal: {
                visivel: false,
                compromisso: null,
                novoResponsavel: ''
            }
        }
    },
    computed: {
        unidadesDisponiveis() {
            const unidades = new Set(this.todosOsCompromissos.map(c => c.unidade_executora));
            return Array.from(unidades).sort();
        },

        compromissosFiltrados() {
            if (this.filtro.unidade_executora === '*') {
                return this.todosOsCompromissos;
            }
            return this.todosOsCompromissos.filter(
                comp => comp.unidade_executora === this.filtro.unidade_executora
            );
        }
    },
    created() {
        this.carregarCompromissos();
    },
    methods: {
        async carregarCompromissos() {
            try {
                const response = await request.get(`planogoverno/compromisso?unidade_executora=*`);
                this.todosOsCompromissos = response.data;
            } catch (error) {
                console.error("Erro ao carregar compromissos:", error);
                this.$toastr.e('Erro ao carregar compromissos.');
            }
        },
        editar(compromisso) {
            this.modal.compromisso = compromisso;
            this.modal.novoResponsavel = compromisso.responsavel_sshd;
            this.modal.visivel = true;
            this.$nextTick(() => {
                this.$refs.selectFuncionario.focus();
            })
        },
        fecharModal() {
            this.modal.visivel = false;
            this.modal.compromisso = null;
            this.modal.novoResponsavel = '';
        },
        async salvarResponsavel() {
            const { id } = this.modal.compromisso;
            const responsavel_sshd = this.modal.novoResponsavel;

            try {
                await request.put(`planogoverno/compromisso/${id}`, { responsavel_sshd });

                const index = this.todosOsCompromissos.findIndex(c => c.id === id);
                if (index !== -1) {
                    this.todosOsCompromissos[index].responsavel_sshd = responsavel_sshd;
                }

                this.$toastr.s('Responsável atualizado com sucesso!');
                this.fecharModal();
            } catch (error) {
                console.error("Erro ao atualizar responsável:", error);
                this.$toastr.e('Erro ao atualizar responsável.');
            }
        }
    }
}
</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    width: 100%;
    max-width: 500px;
    margin: 0px auto;
    padding: 20px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    font-family: 'Helvetica Neue', Arial, sans-serif;
    overflow: visible;
}

.modal-title {
    margin-top: 0;
    color: #00615c;
    font-size: 18px;
    font-weight: bold;
}

.modal-footer {
    margin-top: 15px;
    text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/views/admin/plano-governo/compromisso/EditarResponsaveis.vue